import { IInitialState } from 'store/models';
import { authStateSelector } from './authStateSelector';

export function authErrorSelector(state: IInitialState) {
	return authStateSelector(state).error;
}
